export default __webpack_public_path__ + "img/chain-link.1e441257.svg";